import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AccommodationResponse, AllocateGuestPayload } from './event-accommodation.model';
import { EventGuestModel } from './event-guest.model';
import { ResourceData } from '@app/shared/abstract/resource.data';

@Injectable({ providedIn: 'root' })
export class EventAccommodationService {
  private readonly apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  // The customer portal calls a different prefix (`my-events/...`). The caller
  // passes which mode to use via `customerPortal`.
  private base(eventId: number | string, customerPortal: boolean): string {
    const segment = customerPortal ? 'my-events' : 'events';
    return `${this.apiUrl}/api/${segment}/${eventId}`;
  }

  getAccommodation(eventId: number | string, customerPortal = false): Observable<AccommodationResponse> {
    return this.http.get<AccommodationResponse>(`${this.base(eventId, customerPortal)}/accommodation`);
  }

  allocateGuest(
    eventId: number | string,
    guestId: number,
    payload: AllocateGuestPayload,
    customerPortal = false,
  ): Observable<ResourceData<EventGuestModel>> {
    return this.http.put<ResourceData<EventGuestModel>>(
      `${this.base(eventId, customerPortal)}/guests/${guestId}/room`,
      payload,
    );
  }
}
